import { FunctionComponent, useContext } from 'react'
import { Form, Alert } from 'react-bootstrap'
import { DashboardContext } from '../data/context'
import { VDCounts } from '../lib/structures'

interface Props {
  counts?: VDCounts
}

const VDCategoryFilter: FunctionComponent<Props> = props => {
  const { counts } = props
  const { filterLabel, setFilterLabel } = useContext(DashboardContext)

  return (
    <Alert variant={filterLabel === 'All' ? 'transparent' : 'warning'}>
      <Form.Group className='m-0' controlId='exampleForm.ControlSelect1'>
        <div className='d-md-flex align-items-center'>
          <div className='d-flex col-md-7 mr-2  align-items-center'>
            <Form.Label className='mr-2 mb-0 text-nowrap'>VD Category Filter:</Form.Label>
            <Form.Control style={{ backgroundColor: 'transparent', width: 'fit-content' }} as='select' value={filterLabel} onChange={(e) => setFilterLabel(e.target.value)}>
              <option value='All'>All</option>
              <option value='Microtargeting Only'>Microtargeting Only (DA Support 0% - 24.99%)</option>
              <option value='Microtargeting with Registration'>Microtargeting with Registration (DA Support 25% to 54.99%)</option>
              <option value='Mobilisation'>Mobilisation (DA Support 55% plus)</option>
              <option value='PA Area'>PA Squeeze VD</option>
            </Form.Control>
          </div>
          <strong className='pt-1 pb-1 col-md-5  mb-0'>Showing statistics for {counts?.filtered} of {counts?.total} VDs.</strong>
        </div>
      </Form.Group>
    </Alert>
  )
}
export default VDCategoryFilter
